import * as React from 'react';

type Props = {
    toggleNavigation: () => void;
};

const NavigationTrigger: React.FC<Props> = ({ toggleNavigation }) => (
    <div className="app-header-navigation-trigger">
        <button onClick={toggleNavigation} className="main-navigation-trigger">
            <div className="app-header-button-content">
                <div className="main-navigation-trigger-icon app-header-item-icon"></div>
                <div className="app-header-button-label app-header-item-label">Menu</div>
            </div>
        </button>
    </div>
);

export default NavigationTrigger;
